import { render, staticRenderFns } from "./MedicineOther.vue?vue&type=template&id=92141f6e"
import script from "./MedicineOther.vue?vue&type=script&lang=js"
export * from "./MedicineOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports